import AdvanceTable from "components/common/advance-table/AdvanceTable";
import SubtleBadge from "components/common/SubtleBadge";
import { useAdvanceTable } from "hooks";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import React from "react";

export const PurposesTable = ({ purposes, title }) => {
  const formatID = (id) => `${id.slice(0, 12)}...`;
  const formatText = (text) => `${text.slice(0, 30)}...`;

  const columns = [
    {
      accessorKey: "code",
      header: "Code",
      meta: {
        headerProps: { className: "text-900" },
        cellProps: { className: "text-xxs" },
      },
    },
    {
      accessorKey: "name",
      header: "Name",
      meta: {
        headerProps: { className: "text-900" },
        cellProps: { className: "text-xxs" },
      },
    },
    {
      accessorKey: "active",
      header: "Status",
      cell: ({ getValue }) => {
        const value = getValue();
        const style = {
          backgroundColor: value ? "#e8f7e3" : "#fbe9e7",
          color: value ? "#2e7d32" : "#c62828",
          padding: "3px 8px",
          borderRadius: "6px",
          fontSize: "0.65rem",
          border: value ? "1px solid #d5ebd0" : "1px solid #f5c6cb",
          cursor: "default",
          fontWeight: 600,
        };
        const content = value == true ? "Active" : "Disabled";
        return (
          <span className="py-2" style={style}>
            {content}
          </span>
        );
      },
      meta: {
        headerProps: { className: "text-900" },
        cellProps: { className: "fs-9" },
      },
    },
    {
      accessorKey: "description",
      header: "Description",
      cell: ({ getValue }) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: 300 }}
          title={getValue()}
        >
          {getValue()}
        </span>
      ),
      meta: {
        headerProps: { className: "text-900" },
        cellProps: { className: "text-xxs" },
      },
    },
  ];

  const table = useAdvanceTable({
    data: purposes || [],
    columns: columns,
    sortable: true,
    pagination: true,
    perPage: 10,
  });
  return (
    <>
      <h6 className="fw-bold text-sm">{title}</h6>
      {purposes && purposes.length > 0 ? (
        <AdvanceTableProvider {...table}>
          <AdvanceTable
            headerClassName="bg-200 text-nowrap align-middle"
            rowClassName="btn-reveal-trigger text-nowrap align-middle"
            tableProps={{
              bordered: true,
              striped: true,
              className: "fs-10 mb-0 overflow-hidden",
            }}
          />
        </AdvanceTableProvider>
      ) : (
        <div className="text-xs">
          No purposes found assigned to this application
        </div>
      )}
    </>
  );
};
